const resources = {
    add: 'Add',
    address2Label: 'Apt #, Floor, etc.',
    city: 'City',
    country: 'Country',
    enterZipCode: 'Enter ZIP/Postal Code to see City and State/Region',
    phone: 'Phone Number',
    postalCode: 'Postal Code',
    stateRegion: 'State/Region',
    streetAddress: 'Street Address',
    zipPostalCode: 'ZIP/Postal Code'
};

module.exports = function getResource(label) {
    return resources[label];
};
